import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link as ScrollLink } from 'react-scroll';

const NavBar = () => {
    const [nav, setNav] = useState(false);

    const links = [
        {
            id: 1,
            link: 'home',
        },
        {
            id: 2,
            link: 'about',
        },
        {
            id: 3,
            link: 'portfolio',
        },
        {
            id: 4,
            link: 'experience',
        },
        {
            id: 5,
            link: 'contact',
        },
    ];

    return (
        <div className="flex justify-between items-center w-full h-20 px-4 text-white bg-gray-900 opacity-90 backdrop-blur-60 fixed z-50">
            <div>
                <h1 className='text-5xl font-signature ml-2 cursor-pointer hover:scale-105 duration-200 text-white'>Lanyer</h1>
            </div>

            <ul className="hidden md:flex">
                {links.map(({ id, link }) => (
                    <li
                        key={id}
                        className='px-4 cursor-pointer capitalize font-medium text-white hover:scale-105 duration-200'>
                        <ScrollLink to={link} smooth duration={300}>{link}</ScrollLink>
                    </li>
                ))}
            </ul>

            <div onClick={() => setNav(!nav)} className='cursor-pointer pr-4 z-10 text-white md:hidden'>
                {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
            </div>

            <ul className={`flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-gray-900 to-cyan-900 text-white transition-transform duration-300 ease-in-out transform ${nav ? 'translate-y-0' : '-translate-y-full'}`} style={{ zIndex: 40 }}>
                {links.map(({ id, link }) => (
                    <li
                        key={id}
                        className='px-4 cursor-pointer capitalize py-6 text-4xl'>
                        <ScrollLink
                            onClick={() => setNav(!nav)}
                            to={link}
                            smooth duration={300}>
                            {link}
                        </ScrollLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NavBar;